import { call, put } from "redux-saga/effects";
import {
  addAsset,
  deleteAsset,
  editAsset,
  getAssets,
} from "../../app/components/AssetManagement/helper/assetHelper";
import { modifyAssetAction } from "./actions";

export function* getAssetsSaga(action) {
  try {
    const response = yield call(getAssets, action.storeId);
    yield put(modifyAssetAction(response.data));
  } catch (err) {
  }
}

export function* addAssetSaga(action) {
  try {
    const response = yield call(addAsset, action.asset);
    yield put(modifyAssetAction(response.data));
  } catch (err) {
  }
}
export function* editAssetSaga(action) {
  try {
    const response = yield call(editAsset, action.asset);
    yield put(modifyAssetAction(response.data));
  } catch (err) {
  }
}

export function* deleteAssetSaga(action) {
  try {
    const response = yield call(deleteAsset, action.asset);
    yield put(modifyAssetAction(response.data));
  } catch (err) {
  }
}
